import loadable from '@loadable/component'

import { withLoader } from 'components/system/loadable/withLoader'

export const CashOutLoadable = loadable(
  async () => (await import('./CashOutModal')).CashOutModal,
  withLoader
)
